import { RootState } from "store/index";
import { filterRecipeLevelFoodTags } from "utils/food/foodTag";

const foodTagOptions = (state: RootState) => state.foodTagOptions.data;

const recipeTagOptions = (state: RootState) =>
  filterRecipeLevelFoodTags(state.foodTagOptions.data);

export default { foodTagOptions, recipeTagOptions };
